/**
 * @typedef {{left: number, top: number, width: number, height: number}} Box
 */

/**
 * @param {Box} target
 * @param {Box} reference
 */
export function relative(target, reference) {
	return {
		left: target.left - reference.left,
		top: target.top - reference.top,
		width: target.width,
		height: target.height,
	}
};

/**
 *
 * @param {Box} b1
 * @param {Box} b2
 */
export function merge(b1, b2) {
	const left = Math.min(b1.left, b2.left);
	const right = Math.max(b1.left + b1.width, b2.left + b2.width);
	const top = Math.min(b1.top, b2.top);
	const bottom = Math.max(b1.top + b1.height, b2.top + b2.height);
	return {
		left,
		top,
		width: right - left,
		height: bottom - top,
	};
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/tablePlugin/TableBlock/box.js